.meter {
  width: 100%;
  max-width: 22rem;
  margin: 0 auto;
}

.track {
  position: relative;
  height: 2px;
  width: 100%;
  background: var(--paper-ghost);
  border-radius: 2px;
  overflow: hidden;
}

.fill {
  position: absolute;
  inset: 0 auto 0 0;
  height: 100%;
  background: linear-gradient(90deg, var(--gold), var(--cinnabar));
  box-shadow: 0 0 10px rgba(184, 150, 104, 0.5);
  transition: width 0.35s var(--ease-soft);
}

.caption {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 0.7rem;
  font-family: var(--sans);
  font-size: 0.7rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--paper-faint);
}

.pct {
  color: var(--gold);
  font-variant-numeric: tabular-nums;
}
